import { useSelector } from 'react-redux';
import useSelectedGoal from '@api/hooks/topology/useSelectedGoal';
import useMyInfo from '@api/hooks/auth/useMyInfo';
import { getMeUid, getFullName } from '@api/selectors/auth';
import { getMeLatestUserSubscriptions } from '@selectors/subscription';

const useGetReferralInfo = () => {
  const selectedGoal = useSelectedGoal();
  const userFullName = useMyInfo(getFullName);
  const meUID = useMyInfo(getMeUid);
  const latestUserSubscriptions = useSelector(getMeLatestUserSubscriptions);

  const activeSubscription = latestUserSubscriptions?.find(
    (userSubscription) => userSubscription.time_remaining > 0
  );

  const goalUID =
    selectedGoal?.selectedGoal?.uid ||
    activeSubscription?.subscription?.value?.uid;

  const goalName =
    selectedGoal?.selectedGoal?.name ||
    activeSubscription?.subscription?.value?.name;

  return {
    meUID,
    name: userFullName,
    goalName,
    goalUID
  };
};

export default useGetReferralInfo;
